import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'react-icons-kit'
import './EyeEncode.css';

const propTypes = {
    iconEye: PropTypes.object.isRequired,
    size: PropTypes.number.isRequired,
    iconIdentifier : PropTypes.string.isRequired,
    styleFieldIdentifier : PropTypes.string.isRequired,
    onclick: PropTypes.func.isRequired,
    className: PropTypes.string
};

const defaultProps = {
  iconEye: null,
  size: null,
  iconIdentifier: null,
  styleFieldIdentifier: null
};

class EyeEncode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};    
  }  

  render() {
    return (      
        <span   
           onClick={this.props.onClick} 
           className = {this.props.className}> 
           <Icon  
             icon={this.props.iconEye} 
             size={this.props.size}/> 
        </span>
    );
  }
}

EyeEncode.propTypes = propTypes;
EyeEncode.defaultProps = defaultProps;

export default EyeEncode;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/eyeEncode/EyeEncode.jsx